(function (itxApp) {

    'use strict';

    angular.module('itxApp.common')
        .directive('itxNotifyWhenRepeatFinishedCoverSlider', ItxNotifyWhenRepeatFinishedCoverSliderDrt);

    ItxNotifyWhenRepeatFinishedCoverSliderDrt.$inject = ['$rootScope', '$timeout'];

    /**
     * Fixed Container recalc
     */
    function ItxNotifyWhenRepeatFinishedCoverSliderDrt($rootScope, $timeout) {
        return {
          restrict: 'A',
            link: function (scope) {
                if (scope.$last === true) {
                    $timeout(function () {
                        scope.$emit('repeatFinishedC',scope.$index);
                    });
                }

            }
        };
    }

    /** Public */
    itxApp.common.ItxNotifyWhenRepeatFinishedCoverSliderDrt = ItxNotifyWhenRepeatFinishedCoverSliderDrt;

})(window.itxApp);
